import React from 'react';
import { Link } from 'react-router-dom';
import { HOME_REDESIGN_CITIES } from './cityLinks';
import { useHomeRedesignStrings } from './useHomeRedesignStrings';

const pillBase =
  'inline-flex h-11 items-center gap-2 rounded-full border px-5 font-jakarta text-[15px] font-semibold transition-colors';

const HomeRedesignCities: React.FC = () => {
  const s = useHomeRedesignStrings().cities;

  return (
    <section className="container-chisme py-10 lg:grid lg:grid-cols-[minmax(0,400px)_1fr] lg:items-start lg:gap-16 lg:py-16">
      <h2 className="font-instrument text-4xl leading-tight tracking-[-0.02em] text-[#2a0f2a] sm:text-5xl lg:text-[64px] lg:leading-[0.98] lg:tracking-[-0.022em]">
        <span className="block">{s.h2a}</span>
        <span className="block italic text-chisme-primary">{s.h2b}</span>
      </h2>

      <div className="mt-8 flex flex-wrap gap-2.5 lg:mt-0">
        {HOME_REDESIGN_CITIES.map((city) => (
          <Link
            key={city.slug}
            to={`/ciudades/${city.slug}`}
            className={`${pillBase} border-[rgba(74,33,71,0.1)] bg-white text-[#2a0f2a] hover:border-chisme-primary/30 hover:text-chisme-primary`}
          >
            {city.label}
          </Link>
        ))}
        <span
          className={`${pillBase} border border-dashed border-[rgba(74,33,71,0.1)] text-[#5a3158]`}
        >
          {s.andManyMore}
        </span>
      </div>
    </section>
  );
};

export default HomeRedesignCities;
